/* eslint-disable i18n-scan/no-inline-content */
import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import { useWindowSize } from '../../hooks'
import { footerNavSchema } from '../common/footer/utils/footer-nav-schema'
import { MainNav } from '../main-nav'
import { useApplicationContext } from '../../context/ApplicationContext'
import { useLocation } from 'react-router-dom'
import Analytics from '../common/analytics/analytics'
import DocumentHeaders from '../layout/DocumentHeaders'
import { Link } from '@paypalcorp/pp-react'
import PreArticle from './sections/pre-article'
import SprigScript from '../common/analytics/SprigScript'

export const Page = forwardRef((props, ref) => {
  const { as = 'div', children, ...rest } = props

  const context = useApplicationContext()
  const nonce = context.nonce
  const windowSize = useWindowSize()

  const isDesktop = windowSize.width > 1200
  const Comp = as

  const articleWrapperClasses = [
    `dev_dash__page--article__content--wrapper ${
      isDesktop && context?.currentUser
        ? 'dev_dash__page--article__content--wrapper__logged'
        : ''
    }`,
  ]
    .join(' ')
    .trim()

  const { pathname } = useLocation()
  const DASHBOARD_HOME = '/'

  const links = footerNavSchema.map((l, i) => (
    <Link
      key={`${l.text}-${i}`}
      secondary
      href={l.link}
      className="footerLinks footerText"
      target={l.target}
    >
      {l.text}
    </Link>
  ))

  return (
    <>
      <DocumentHeaders pathname={pathname} />
      <MainNav pathname={pathname} />
      <Analytics pathname={pathname} context={context} />
      <SprigScript nonce={nonce} />
      <Comp className="dev_dash__page--container" ref={ref} {...rest}>
        <div className="dev_dash__page--wrapper">
          <main className="dev_dash__page--main">
            <article className="dev_dash__page--article">
              <div className="dev_dash__page--article__container">
                <div className="dev_dash__page--article__content--padding" />
                {context.user && pathname === DASHBOARD_HOME && <PreArticle />}
                <div
                  className={
                    context.banner.isActive === 'on' && !context.isBannerHidden
                      ? 'dev_dash__page--article__wrapper_banner'
                      : 'dev_dash__page--article__wrapper'
                  }
                >
                  <div className="dev_dash__page--article__content--container">
                    <div
                      className={articleWrapperClasses}
                      style={{ marginTop: '3rem' }}
                    >
                      {children}
                    </div>
                  </div>
                </div>
              </div>
            </article>
            <div className="footerContainer">
              <div className="footerWrapper">
                <div className="linkBtnContainer">{links}</div>
              </div>
            </div>
          </main>
        </div>
      </Comp>
    </>
  )
})

Page.displayName = 'Page'

Page.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
